<script setup>
import { ref, computed, watch } from 'vue';
import { useRuntimeConfig } from "nuxt/app";
const config = useRuntimeConfig();

const props = defineProps({
  imageClickable: {
    type: Boolean,
    default: true
  },
  user: {
    type: Object,
    default() {
      return {};
    }
  },
  size: {
    type: String,
    default: 'small'
  }
});

const imageOpen = ref(false);
const item = ref(props.user);

const avatarUrls = computed(() => {
  if (item.value?.imageFileName) {
    const baseUrl = config.public.storageBaseUrl;
    return {
      thumbnail: `${baseUrl}/thumbnail_${item.value.imageFileName}`,
      medium: `${baseUrl}/medium_${item.value.imageFileName}`,
      large: `${baseUrl}/large_${item.value.imageFileName}`,
      original: `${baseUrl}/${item.value.imageFileName}`,
    };
  }
  return null;
});

const avatarInitial = computed(() => {
  if (avatarUrls.value !== null) return '';
  // X182 (R80 L7): a row that carries only fullName (the waiting area's club-managed players) still gets initials, never a
  // bare coloured circle; a missing last name no longer throws.
  const first = item.value?.firstName?.trim?.() ?? '';
  const last = item.value?.lastName?.trim?.() ?? '';
  if (first || last) return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  const words = String(item.value?.fullName ?? item.value?.name ?? '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  return (words.length === 1 ? words[0].charAt(0) : `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`).toUpperCase();
});

watch(
    () => props.user,
    (newValue) => {
      item.value = newValue;
    }
);
</script>

<template>
  <v-avatar class="bg-primary text-white font-weight-bold" :size="size === 'small' ? 24 : (size === 'medium' ? 40 : (size === 'large' ? 60 : 120))">
    <v-img
        :class="imageClickable ? 'cursor' : ''"
        @click="() => { if (imageClickable) imageOpen = true; }"
        cover
        v-if="avatarUrls"
        :src="avatarUrls.thumbnail"
    />
    <v-dialog
        :fullscreen="true"
        v-if="avatarUrls && imageClickable"
        :close-on-content-click="true"
        v-model="imageOpen"
        class="pa-5"
    >
      <v-img v-if="avatarUrls" :src="avatarUrls.large" />
    </v-dialog>
    <span
        :style="size === 'small' ? 'font-size: 12px;' : (size === 'medium' ? 'font-size: 18px;' : 'font-size: 30px;')"
        v-else
    >
      {{ avatarInitial }}
    </span>
  </v-avatar>
</template>

<style scoped></style>
